import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";
import {AtsRecordsColumnApiModel} from "./ats-records.column.api-model";

export class AtsRecordsColumnDomainModel extends BaseDomainModel {
  apiModel: AtsRecordsColumnApiModel;

  get name(): String {
    return this.apiModel.name;
  }
}
